export const config = {
  hasuraGraphqlUrl:
    import.meta.env.VITE_HASURA_GRAPHQL_URL || "https://api.pufferfish.bot/v1/graphql",
  appName: import.meta.env.VITE_APP_NAME || "Pufferfish",
  googleClientId:
    import.meta.env.VITE_GOOGLE_CLIENT_ID ||
    "3856374287-hndqdc426gljtft8no13ge9cm9vj5oha.apps.googleusercontent.com",
};
